module.exports = __webpack_public_path__ + "img/folder.e7f3d060.svg";